import React, { useContext, useRef, useState } from 'react';
import { FaFilePdf, FaPlus } from 'react-icons/fa';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import { _imagesURL, AddClinicalStudies, AddSurvay } from '../../../constants/API';
import Cropper from "../../../../src/cropper/components/CroppersWizard.tsx";
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { Language } from '../../../App';
import { toast } from 'react-toastify';
import axios from 'axios';
import { RiImageAddLine, RiSparkling2Fill, RiFileList3Line } from 'react-icons/ri';
import { IoCloseSharp } from 'react-icons/io5';
import PostImageModal from './PostImageModal';
import ImageShowModal from '../../common/ImageShowModal.jsx';
import { useCheckSubscriptionPermission } from '../../../hooks/useCheckSubscriptionPermission';
import './formTheme.css';

function ClinicalStudyTab({ onHide, setProgress, handleApiCall, refetch }) {
  const { lang } = useContext(Language);
  const checkPermission = useCheckSubscriptionPermission('create_clinical_study');
  const childRef = useRef(null);

  const SplashData = JSON.parse(localStorage.getItem("SplashData") || "{}");
  const sub_category = SplashData?.home?.subcategories || [];
  const { data: userToken } = JSON.parse(localStorage.getItem("SignupData") || "{}");
  const [pdf, setPdf] = useState("");
  const [imagesUrl, setImagesUrl] = useState([]);
  const [type, setType] = useState("");
  const [showImageModal, setShowImageModal] = useState(false);
  const [qsModal, setQsModal] = useState(false);
  const [showProgress, setShowProgress] = useState(false);
  const [qs, setQs] = useState([{ question: "", answers: ["", "", ""] }]);
  const [savedQs, setSavedQs] = useState([]);
  const [isImagePreviewOpen, setIsImagePreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const toggleImagePreview = () => setIsImagePreviewOpen(!isImagePreviewOpen);
  const handleImageClick = (img) => {
    setPreviewImage(img);
    toggleImagePreview();
  };
  const [coverImg, setCoverImg] = useState([]);
  const [imgArr, setImgArr] = useState([]);
  const [cropperOpen, setCropperOpen] = useState(false);
  const maxNumber = 6;
  const [ar, setAR] = useState(1);
  const [maxARatio, setMaxAR] = React.useState(undefined);
  const [minARatio, setMinAR] = React.useState(undefined);
  const [resizable, setResizable] = useState(true);
  const [hasSettings, setHasSettings] = useState(true);
  const [updateCoordinatesCheck, setUpdateCoordinatesCheck] = useState(false);
  const [fileUploadRefs, setFileUploadRefs] = React.useState({});
  const [numberOfImages, setNumberOfImages] = React.useState(maxNumber);
  const [height, setHeight] = React.useState(undefined);
  const [width, setWidth] = React.useState(undefined);
  const [top, setTop] = React.useState(undefined);
  const [left, setLeft] = React.useState(undefined);
  const [formData, setFormData] = useState({
    title: '',
    category: '',
    description: '',
    file: null,
  });
  const [isTruncated, setIsTruncated] = useState(true);
  const toggleTruncate = () => {
    setIsTruncated(!isTruncated);
  };

  const getImagesUrl = (url) => {
    setImagesUrl(url);
  };
  const handleClose = () => {
    setCropperOpen(false);
  };
  const onImageRemove = (index) => {
    const updatedImages = Array.isArray(imgArr) ? [...imgArr] : Object.values(imgArr || {});
    const updatedFileUploadRefs = { ...fileUploadRefs };
    updatedImages.splice(index, 1);
    if (fileUploadRefs[index + 1] && fileUploadRefs[index + 1].current) {
      fileUploadRefs[index + 1].current.value = '';
    }
    setCoverImg(updatedImages);
    setImgArr(updatedImages);
    const newFileUploadRefs = {};
    Object.keys(updatedFileUploadRefs)
      .filter((key) => key !== index.toString())
      .forEach((key, newIndex) => {
        newFileUploadRefs[newIndex] = updatedFileUploadRefs[key];
      });

    setFileUploadRefs(newFileUploadRefs);
    if (updatedImages.length === 0) {
      setHasSettings(true);
      setAR(undefined);
      setMinAR(undefined);
      setMaxAR(undefined);
      setWidth(500);
      setHeight(500);
      setTop(0);
      setLeft(0);
      setCropperOpen(false);
    }
  };
  const handleImageUploadClick = () => {
    const currentIndex = numberOfImages - 1;
    if (fileUploadRefs[currentIndex] && fileUploadRefs[currentIndex].current) {
      fileUploadRefs[currentIndex].current.value = '';
      fileUploadRefs[currentIndex].current.click();
    }
  };
  const handleSubmit = async () => {
    setShowProgress(true);
    onHide();
    const data = {
      title: formData.title,
      type: "clinical-image",
      category: "3",
      subcategory: formData.category,
      caption: formData.description,
      mediaBase64: imgArr,
    };
    try {
      const res = await axios.post(AddClinicalStudies, data, {
        onUploadProgress: (progressData) => {
          setProgress(Math.round((100 * progressData.loaded) / progressData.total));
        },
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userToken?.token}`,
        },
      });

      if (res.data.status) {
        setShowProgress(false);
        handleSurvay(res.data.post.id, qs);
        onHide();
        return res;
      } else {
        setShowProgress(false);
        toast.error(res.data.action);
      }
    } catch (error) {
      setShowProgress(false);
      console.error(error);
      toast.error("Something went wrong. Please try again.");
    }
  };

  const handleSurvay = (post_id, questionsData) => {
    if (!questionsData || questionsData.length === 0) {
      return;
    }
    const questions = [];
    const option1 = [];
    const option2 = [];
    const option3 = [];
    questionsData.forEach((item) => {
      questions.push(item.question);
      option1.push(item.answers[0]);
      option2.push(item.answers[1]);
      option3.push(item.answers[2]);
    });
    const data = { pdf, questions, option1, option2, option3, post_id };
    axios
      .post(AddSurvay, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userToken?.token}`,
        },
      })
      .then((res) => {
        if (res.data.status) {
          refetch();
        } else {
          toast.error(res.data.action);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const _handleSubmit = async (e) => {
    e.preventDefault();
    if (!checkPermission()) return;
    await handleApiCall(() => handleSubmit(), { type: "clinical-study" });
  };

  const truncatedName = pdf?.name?.length > 45 ? `${pdf.name.slice(0, 45)}...` : pdf?.name;
  const surveyQuestionsCount = qs.filter((q) => q.question.trim()).length;

  return (
    <>
      <div className="pf-form-body">
        {/* AI Banner */}
        <div className="pf-ai-banner">
          <div className="pf-ai-banner-left">
            <RiSparkling2Fill className="pf-ai-banner-sparkle" size={15} />
            <span>Peer-Reviewed Clinical Study & Case Report</span>
          </div>
          <span className="pf-ai-banner-tag">Clinical Trial Registry</span>
        </div>

        <form onSubmit={_handleSubmit}>
          {/* Title & Category Grid */}
          <div className="pf-grid-2">
            <div className="pf-field">
              <div className="pf-label">
                <span className="pf-label-text">{lang?.title || "Study Title"}</span>
              </div>
              <input
                type="text"
                className="pf-input"
                placeholder={lang?.clinical_study_title || "e.g., Efficacy of Novel Corneal Crosslinking Protocol"}
                value={formData.title}
                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              />
            </div>

            <div className="pf-field">
              <div className="pf-label">
                <span className="pf-label-text">{lang?.category || "Medical Subspecialty"}</span>
              </div>
              <select
                className="pf-select"
                value={formData.category}
                onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                style={{ color: formData.category === "" ? "#94A3B8" : "#0B132B" }}
              >
                <option value="" style={{ color: "#94A3B8" }}>
                  {lang?.case_study_category || "Select medical field"}
                </option>
                {sub_category.map((value) => (
                  <option value={value.id} key={value.id} style={{ color: "#0B132B" }}>
                    {value.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Description Textarea */}
          <div className="pf-field">
            <div className="pf-label">
              <span className="pf-label-text">{lang?.description || "Study Abstract & Clinical Methodology"}</span>
            </div>
            <textarea
              className="pf-textarea"
              rows={3}
              placeholder={lang?.clinical_study_description || "Detail the patient cohort, clinical interventions, statistical methodology, and conclusions..."}
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
            />
          </div>

          {/* Attachments Section Card */}
          <div className="pf-card-section d-flex flex-column gap-3">
            <span className="fs-13 fw-600" style={{ color: "#0B132B" }}>Attachments & Survey Data</span>

            <div className="pf-grid-2">
              {/* PDF Document Upload */}
              <div className="pf-field">
                <div className="pf-label">
                  <span className="pf-label-text">{lang?.attach_complete_clinical_study_pdf || "Full Study PDF"}</span>
                  <span className="pf-optional-badge">Required</span>
                </div>
                <div className="d-flex gap-2 flex-wrap align-items-center">
                  <button
                    type="button"
                    className="pf-chip-btn"
                    onClick={() => document.getElementById('pdfinput').click()}
                  >
                    <FaFilePdf size={13} color="#10B981" />
                    <span>{pdf ? (lang?.change_pdf || "Replace PDF") : (lang?.upload_pdf || "Upload PDF")}</span>
                  </button>
                  <input
                    type="file"
                    id="pdfinput"
                    className="d-none"
                    accept=".pdf"
                    onChange={(e) => {
                      const pdfFile = e.target.files[0];
                      if (pdfFile) setPdf(pdfFile);
                    }}
                  />
                  {pdf && (
                    <div className="pf-file-chip">
                      <FaFilePdf size={16} color="#059669" className="cursor flex-shrink-0" />
                      <span
                        className="pf-file-name"
                        title={pdf.name}
                        onClick={() => {
                          const fileURL = URL.createObjectURL(pdf);
                          window.open(fileURL, "_blank");
                          URL.revokeObjectURL(fileURL);
                        }}
                      >
                        {truncatedName}
                      </span>
                      <button
                        type="button"
                        className="pf-file-remove"
                        aria-label="Remove PDF"
                        onClick={() => setPdf("")}
                      >
                        <IoCloseSharp size={13} />
                      </button>
                    </div>
                  )}
                </div>
              </div>

              {/* Survey Questions Trigger */}
              <div className="pf-field">
                <div className="pf-label">
                  <span className="pf-label-text">{lang?.add_survey || "Study Survey"}</span>
                  <span className="pf-optional-badge">Optional</span>
                </div>
                <div>
                  <button
                    type="button"
                    className="pf-chip-btn"
                    onClick={() => setQsModal(true)}
                  >
                    <RiFileList3Line size={14} color="#10B981" />
                    <span>{lang?.add_question || "Build Questions"}</span>
                    {surveyQuestionsCount > 0 && (
                      <span className="pf-chip-count">{surveyQuestionsCount}</span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Media Images Dropzone & Thumbnails */}
          {(() => {
            const imageList = Array.isArray(imgArr) ? imgArr : Object.values(imgArr || {});
            return imageList.length === 0 ? (
              <div className="pf-upload-zone" onClick={handleImageUploadClick}>
                <div className="pf-upload-zone-left">
                  <div className="pf-upload-icon-circle">
                    <RiImageAddLine size={20} />
                  </div>
                  <div>
                    <div className="pf-upload-zone-title">Upload Clinical Case Images / Scans</div>
                    <div className="pf-upload-zone-sub">High-resolution pathology, radiological, or surgical photographs</div>
                  </div>
                </div>
                <button type="button" className="pf-chip-btn">
                  Add Images
                </button>
              </div>
            ) : (
              <div className="pf-thumb-strip">
                {imageList.map((img, index) => (
                  <div key={index} className="pf-thumb" style={{ width: "115px", height: "115px" }}>
                    <PhotoProvider
                      speed={() => 800}
                      easing={(type) =>
                        type === 2
                          ? 'cubic-bezier(0.36, 0, 0.66, -0.56)'
                          : 'cubic-bezier(0.34, 1.56, 0.64, 1)'
                      }
                    >
                      <PhotoView src={img}>
                        <img
                          className="cursor"
                          src={img}
                          onClick={() => handleImageClick(img)}
                          alt="Uploaded"
                          style={{
                            width: '115px',
                            height: "115px",
                            objectFit: "cover",
                            display: "block",
                          }}
                        />
                      </PhotoView>
                    </PhotoProvider>
                    <button
                      type="button"
                      className="pf-thumb-remove"
                      aria-label="Remove"
                      onClick={() => onImageRemove(index)}
                    >
                      <IoCloseSharp size={14} />
                    </button>
                  </div>
                ))}
              </div>
            );
          })()}

          {/* Bottom Actions (Clean cancel & publish only) */}
          <div className="pf-footer-row" style={{ justifyContent: "flex-end" }}>
            <div className="pf-footer-actions">
              <button type="button" className="pf-btn-cancel" onClick={onHide}>
                {lang?.cancel || "Cancel"}
              </button>
              <button
                type="submit"
                disabled={!formData.title || !formData.category || !formData.description || !imgArr.length || !pdf}
                className="pf-btn-submit"
              >
                <span>{lang?.publish || "Publish Clinical Study"}</span>
              </button>
            </div>
          </div>
        </form>

        <Cropper
          images={coverImg}
          setImages={setCoverImg}
          setImagesArr={setImgArr}
          imagesArr={imgArr}
          value={coverImg}
          max={maxNumber}
          allowCrop={true}
          ar={ar}
          setAR={setAR}
          minARatio={minARatio}
          setMaxAR={setMaxAR}
          maxARatio={maxARatio}
          setMinAR={setMinAR}
          resizable={resizable}
          setResizable={setResizable}
          handleClose={handleClose}
          fileUploadRefs={fileUploadRefs}
          setFileUploadRefs={setFileUploadRefs}
          numberOfImages={numberOfImages}
          setNumberOfImages={setNumberOfImages}
          hasSettings={hasSettings}
          setHasSettings={setHasSettings}
          updateCoordinatesCheck={updateCoordinatesCheck}
          setUpdateCoordinatesCheck={setUpdateCoordinatesCheck}
          height={height}
          setHeight={setHeight}
          width={width}
          setWidth={setWidth}
          top={top}
          setTop={setTop}
          left={left}
          setLeft={setLeft}
          cropperOpen={cropperOpen}
          setCropperOpen={setCropperOpen}
        />
      </div>

      <PostImageModal
        ref={childRef}
        type={type}
        getVideoSource={null}
        getImagesUrl={getImagesUrl}
        showModal={showImageModal}
        setShowModal={setShowImageModal}
      />

      {/* Survey Questions Modal */}
      <Modal
        isOpen={qsModal}
        toggle={() => setQsModal(false)}
        centered
        scrollable
        className="pf-modal pf-scope-study"
      >
        <div className="pf-modal-header-wrapper">
          <h6 className="fs-15 fw-600 mb-0" style={{ color: "#0B132B" }}>
            {lang?.add_question || "Build Survey Questions"}
          </h6>
          <button
            type="button"
            className="pf-modal-close-btn"
            onClick={() => setQsModal(false)}
            aria-label="Close"
          >
            <IoCloseSharp size={18} />
          </button>
        </div>

        <ModalBody className="pf-modal-body">
          {qs.map((value, index) => (
            <div
              key={index}
              className="pf-card-section mb-3"
            >
              <div className="d-flex gap-2 align-items-center mb-2">
                <span
                  style={{
                    width: "24px",
                    height: "24px",
                    borderRadius: "50%",
                    background: "var(--pf-accent-light)",
                    color: "var(--pf-accent-dark)",
                    fontSize: "11px",
                    fontWeight: 700,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  {index + 1}
                </span>
                <input
                  type="text"
                  className="pf-input"
                  placeholder={lang?.write_question_here || "Write clinical survey question..."}
                  value={value.question}
                  onChange={(e) => {
                    const updatedQuestionsData = [...qs];
                    updatedQuestionsData[index] = {
                      question: e.target.value,
                      answers: qs[index].answers,
                    };
                    setQs(updatedQuestionsData);
                  }}
                />
              </div>

              <div className="d-flex flex-column gap-2 ps-4 mt-2">
                {value.answers.map((data, id) => (
                  <input
                    key={id}
                    type="text"
                    className="pf-input"
                    placeholder={`${lang?.write_option_here || "Option"} ${id + 1}`}
                    value={data}
                    onChange={(e) => {
                      const updatedQuestionsData = [...qs];
                      updatedQuestionsData[index].answers[id] = e.target.value;
                      setQs(updatedQuestionsData);
                    }}
                  />
                ))}
              </div>
            </div>
          ))}

          <div className="text-end mt-2">
            <button
              type="button"
              className="pf-chip-btn"
              onClick={() => {
                let disable = false;
                qs.forEach((value) => {
                  if (value.question === "") {
                    disable = true;
                    toast.error(lang?.enter_question_please || "Please enter a question.");
                  }
                  value.answers.forEach((data) => {
                    if (data === "") {
                      disable = true;
                      toast.error(lang?.enter_option_please || "Please enter all options.");
                    }
                  });
                });
                if (!disable) {
                  setSavedQs([...qs]);
                  const newQuestion = { question: "", answers: ["", "", ""] };
                  const updatedQuestionsData = [...qs];
                  updatedQuestionsData.push(newQuestion);
                  setQs(updatedQuestionsData);
                }
              }}
            >
              <FaPlus size={10} color="#10B981" /> {lang?.add_question || "Add Another Question"}
            </button>
          </div>
        </ModalBody>

        <ModalFooter
          className="pf-footer-row"
          style={{
            borderTop: "1px solid #EEF2F6",
            padding: "14px 22px",
            margin: 0,
            background: "#FFFFFF",
          }}
        >
          <div className="d-flex w-100 gap-2">
            <button
              type="button"
              className="pf-btn-cancel w-100"
              onClick={() => setQsModal(false)}
            >
              {lang?.cancel || "Cancel"}
            </button>
            <button
              type="button"
              className="pf-btn-submit w-100"
              onClick={() => {
                setQsModal(false);
              }}
            >
              {lang?.save || "Save Survey"}
            </button>
          </div>
        </ModalFooter>
      </Modal>

      <ImageShowModal
        isOpen={isImagePreviewOpen}
        toggle={toggleImagePreview}
        imageSrc={previewImage}
      />
    </>
  );
}

export default ClinicalStudyTab;
